// @flow
import DiamondSpecTable from '@components/productDetail/DiamondSpecTable';

import LinkPopup from '@components/popups/Link';
import * as ClarityContent from '@components/popups/content/Clarity';

const clarities = [
  {
    symbol: 'FL',
    descriptions: [
      'This FL diamond has no internal or external flaws, even when viewed under a magnifier.   FL diamonds are extremely rare; less than 1 in 5000 jewelry quality diamonds is rated FL by the GIA.'
    ]
  },
  {
    symbol: 'IF',
    descriptions: [
      'This IF diamond has no internal flaws.   Any external flaws are very slight, visible only to a trained observer under 10x magnification.  Less than 3% of jewelry quality diamonds are rated IF by the GIA.'
    ]
  },
  {
    symbol: 'VVS1',
    descriptions: [
      'This VVS1 diamond has very, very slight inclusions, invisible without magnification.  Even magnified, flaws are nearly impossible to see by the untrained observer. Only 5% of jewelry quality diamonds are rated VVS1.'
    ]
  },
  {
    symbol: 'VVS2',
    descriptions: [
      'This VVS2 diamond has very, very slight inclusions, invisible without magnification.  Even magnified, flaws are nearly impossible to see by the untrained observer. Only 10% of jewelry quality diamonds are rated VVS2.'
    ]
  },
  {
    symbol: 'VS1',
    descriptions: [
      'This VS1 diamond has very slight inclusions, invisible without magnification.  While appearing flawless, VS1 diamonds typically sell for 20-35% less than an FL diamond.'
    ]
  },
  {
    symbol: 'VS2',
    descriptions: [
      'This VS2 diamond has very slight inclusions, invisible to the casual observer without magnification.  While appearing flawless, VS2 diamonds typically sell for 25-40% less than an FL diamond.'
    ]
  },
  {
    symbol: 'SI1',
    descriptions: [
      'This SI1 diamond has inclusions visible under magnification.  SI1 is the lowest clarity with inclusions that are often invisible to the naked eye.  An SI1 diamond will typically sell for 15-25% less than a VS1 diamond.'
    ]
  },
  {
    symbol: 'SI2',
    descriptions: [
      'This SI2 diamond has inclusions visible under magnification.  SI2 inclusions are usually visible to the naked eye, although close inspection is required. An SI2 diamond will typically sell for 10-15% less than an SI1 diamond.'
    ]
  },
  {
    symbol: 'I1',
    descriptions: [
      'This I1 diamond has inclusions that are almost always visible to the naked eye, although often difficult to see in diamonds under 1.00 carat.  An exceptional value, I1 diamonds typically sell for 40% less than SI1 diamonds.'
    ]
  }
];

const Popup = ({ children, className, style = {} }) => (
  <LinkPopup
    initialContent={ClarityContent}
    className={className}
    style={style}
  >
    {children}
  </LinkPopup>
);

class DiamondClarityTable extends React.Component<{ clarity: string }> {
  render() {
    const idx = clarities.map(c => c.symbol).indexOf(this.props.clarity);
    return (
      <DiamondSpecTable
        index={idx}
        spec={'clarity'}
        items={clarities}
        style={{ marginBottom: '-8px' }}
        Popup={Popup}
      />
    );
  }
}

export default DiamondClarityTable;
